export default __webpack_public_path__ + "static/Alameda-4306c4c5fa8e65001efc5d8113d66d23.png";